

import React, { useState } from "react";
import styles from "./LogoutModal.module.scss";
import Modal from "../Modal/Modal";
import Button from "../../Button/Button";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import { useDispatch } from "react-redux";
import { isUserLogin } from "../../../../features/persist/persistSlice";
import toast from "react-hot-toast";
import { logoutUserAction } from "../../../../features/user/userSlice";
import { toasts } from "../../Toast/Toast";

const LogoutModal = ({ show, handleClose }) => {
  const [loggingOut, setLoggingOut] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    if (loggingOut) return; // Prevent multiple clicks while logging out
    try {
      setLoggingOut(true);
      const response = await dispatch(logoutUserAction());
      if (response?.status === 200) {
        dispatch(isUserLogin(false));
        toasts.success("Logged Out");
        navigate(ROUTES.LOGIN);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title="Please Confirm"
      className={styles.logout}
    >
      <h3>Are you sure you want to logout?</h3>
      <div className={styles.action}>
        <Button variant="bordered_grey" fluid onClick={handleClose}>
          No, Go Back
        </Button>
        <Button variant="danger_filled" fluid onClick={handleLogout} disabled={loggingOut}>
          Yes, Logout
        </Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;

